import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {Popup, setOptions, Input, confirm, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderConversations.css';
import Truncate from "../utils/Truncate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faSliders,
    faPipe,
    faPlus,
    faMessageQuestion,
    faPlay,
    faEllipsisStrokeVertical,
    faArrowDownWideShort,
    faArrowUpShortWide
} from "@fortawesome/pro-duotone-svg-icons";
import dayjs from "dayjs";
import Avatar from "../utils/Avatar";
import Loading from "../utils/Loading";
import Empty from "../utils/Empty";
import TabOrder from "../utils/TabOrder";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderConversations({dialog, Dialog, width, navigation, configuration, locale, setTeamtalk, setQuickQuestion, setArchive, setToast, teamtalk}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const sortStart = useRef(null);
    const [conversations, setConversations] = useState([]);
    const [teamtalks, setTeamtalks] = useState([]);
    const [archives, setArchives] = useState([]);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState('conversations');
    const [text, setText] = useState(null);
    const [sort, setSort] = useState(true);
    const [listInstance, setListInstance] = useState({});

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Conversations = () => {
        if (!loading) {
            setLoading(true);
        }
        if (text) {
            setText(null);
        }

        const message = {
            type: 'wss',
            path: 'conversations',
            action: 'get',
            data: {}
        };
        wsCall(message);
    }

    const Teamtalks = () => {
        if (!loading) {
            setLoading(true);
        }
        if (text) {
            setText(null);
        }

        const message = {
            type: 'wss',
            path: 'teamtalk-conversations',
            action: 'get',
            data: {}
        };
        wsCall(message);
    };

    const Archives = () => {
        if (!loading) {
            setLoading(true);
        }
        if (text) {
            setText(null);
        }

        const message = {
            type: 'wss',
            path: 'conversation-archives',
            action: 'get',
            data: {}
        };
        wsCall(message);
    }

    const Model = data => {
        if (configuration.ui.dashboard.model) {
            const item = configuration.mobi.model.find(item => item.value === data);
            return item ? item.short : null;
        } else {
            return null;
        }
    }

    const Sort = data => {
        const start = sortStart.current;

        const isValidIndex = (i) => Number.isInteger(i) && i >= 0 && i < conversations.length;

        if (!isValidIndex(start) || !isValidIndex(data) || start === data) {
            return;
        }

        const next = [...conversations];
        const [item] = next.splice(start, 1);
        next.splice(data, 0, item);

        setConversations(next);

        const message = {
            type: 'wss',
            path: 'tab-sort',
            action: 'update',
            data: {
                tabs: next.map((tab) => tab.id)
            }
        };
        wsCall(message);
    }

    const Settings = data => {
        Dialog({view: 'dashboardQuestionSettings'});
    }

    const Question = data => {
        setQuickQuestion(data);
        Dialog({view: 'dashboardHeaderQuestion'});
    }

    const ListItemConversations = data => {
        const avatar = data.item.avatar ? data.item.avatar : null;
        const voice = data.item.voice? data.item.voice : 'nova';
        const personality = Object.values(configuration.mobi.personalities).flat().find(item => item.value === data.item.personality);
        const personalityText = personality.text.split('|')[0].trim();

        return <li key={data.item.id} className="cs-dashboard-header-conversations-li" data-selected={navigation.tab === data.item.id ? true : false}>
            <div className="mbsc-row cs-dashboard-header-conversations-list" >
                <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => navigation.tab !== data.item.id ? ListClickConversations(data.item) : null} >
                    {data.item.new ?
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon-teamtalk" icon={faPlus} />
                    :
                        <div style={{backgroundImage: Avatar({avatar, voice, configuration})}} className="cs-dashboard-header-conversations-avatar" />
                    }
                </div>
                <div className={data.item.new ? "mbsc-col cs-dashboard-header-conversations-section-teamtalk" : "mbsc-col cs-dashboard-header-conversations-section"} onClick={() => navigation.tab !== data.item.id ? ListClickConversations(data.item) : null}>
                    <div className="mbsc-bold mbsc-txt-muted">{width < 768 ? Truncate(data.item.name, 30) : Truncate(data.item.name, 60)}</div>
                    {!data.item.new &&
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-conversations-txt">
                            <span className="mbsc-txt-muted">{personalityText}</span>
                            {Model(data.item.model) && <FontAwesomeIcon className="cs-dashboard-header-conversations-pipe" icon={faPipe} />}
                            <span className="mbsc-txt-muted">{Model(data.item.model)}</span>
                        </div>
                    }
                </div>
                {data.item.timestamp &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" >
                        <FontAwesomeIcon beatFade={true} className="cs-dashboard-header-conversations-icon-play mbsc-txt-muted" icon={faPlay} />
                    </div>
                }
                {navigation.tab === data.item.id && !data.item.timestamp &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => Settings(data.item)} >
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon mbsc-bold" icon={faSliders} />
                    </div>
                }
                {((navigation.tab !== data.item.id) || data.item.timestamp) &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => Question(data.item)} >
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon mbsc-txt-muted" icon={faMessageQuestion} />
                    </div>
                }
            </div>
        </li>;
    }

    const ListItemTeamtalks = data => {
        const avatar = data.item.avatar ? data.item.avatar : null;
        const voice = data.item.voice? data.item.voice : 'nova';
        const personality = Object.values(configuration.mobi.personalities).flat().find(item => item.value === data.item.personality);
        const personalityText = personality.text.split('|')[0].trim();

        return <li key={data.item.id} className="cs-dashboard-header-conversations-li" data-selected={navigation.tab === data.item.id ? true : false}>
            <div className="mbsc-row cs-dashboard-header-conversations-list" >
                <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => ListClickTeamtalks(data.item)} >
                    {data.item.new ?
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon-teamtalk" icon={faPlus} />
                        :
                        <div style={{backgroundImage: Avatar({avatar, voice, configuration})}} className="cs-dashboard-header-conversations-avatar" />
                    }
                </div>
                <div className={data.item.new ? "mbsc-col cs-dashboard-header-conversations-section-teamtalk" : "mbsc-col cs-dashboard-header-conversations-section"} onClick={() => ListClickTeamtalks(data.item)}>
                    <div className="mbsc-bold mbsc-txt-muted">{width < 768 ? Truncate(data.item.name, 30) : Truncate(data.item.name, 60)}</div>
                    {!data.item.new &&
                        <div className="mbsc-row mbsc-txt-s cs-dashboard-header-conversations-txt">
                            <span className="mbsc-txt-muted">{personalityText}</span>
                            {Model(data.item.model) && <FontAwesomeIcon className="cs-dashboard-header-conversations-pipe" icon={faPipe} />}
                            <span className="mbsc-txt-muted">{Model(data.item.model)}</span>
                        </div>
                    }
                </div>
                {data.item.timestamp &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" >
                        <FontAwesomeIcon beatFade={true} className="cs-dashboard-header-conversations-icon-play mbsc-txt-muted" icon={faPlay} />
                    </div>
                }
                {navigation.tab === data.item.id && !data.item.timestamp &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => Settings(data.item)} >
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon mbsc-bold" icon={faSliders} />
                    </div>
                }
                {((navigation.tab !== data.item.id) || data.item.timestamp) &&
                    <div className="mbsc-col-auto cs-dashboard-header-conversations-item" onClick={() => Question(data.item)} >
                        <FontAwesomeIcon className="cs-dashboard-header-conversations-icon mbsc-txt-muted" icon={faMessageQuestion} />
                    </div>
                }
            </div>
        </li>;
    }

    const ListItemArchives = data => {
        const itemDate = dayjs(parseInt(data.item.timestamp)).format("MMMM D, YYYY @ h:mm A");

        return <li data-id={data.item.timestamp} onClick={() => listInstance.openActions(data.item.timestamp, 'left')} >
            <div className="mbsc-row cs-dashboard-header-conversations-list" >
                <div className="mbsc-col cs-dashboard-header-conversations-item" >
                    <div className="mbsc-bold mbsc-txt-muted">{width < 992 ? Truncate(data.item.text, 15) : Truncate(data.item.text, 30)}</div>
                    <div className="mbsc-row mbsc-txt-muted mbsc-txt-s cs-dashboard-header-conversations-txt">
                        {itemDate}
                    </div>
                </div>
                <div className="mbsc-col-auto cs-dashboard-header-conversations-item" >
                    <FontAwesomeIcon className="cs-dashboard-header-conversations-icon-archives" icon={faEllipsisStrokeVertical} />
                </div>
            </div>
        </li>;
    }

    const ListItem = data => {
        if (tab === 'archives') {
            return ListItemArchives(data);
        } else if (tab === 'teamtalks') {
            return ListItemTeamtalks(data);
        } else if (tab === 'conversations') {
            return ListItemConversations(data);
        }
    }

    const ListClickTeamtalks = data => {
        if (tab === 'teamtalks' && data.new) {
            Dialog({view: 'dashboardHeaderConversationNew', tab: 'teamtalk'})
        } else if (tab === 'teamtalks' && !data.new) {
            setTeamtalk(data.id);

            const message = {
                type: 'wss',
                path: 'teamtalk-conversation',
                action: 'get',
                data: {
                    teamtalk: data.id
                }
            };
            wsCall(message);
            DialogClose();
        }
    }

    const ListClickConversations = data => {
        setLoading(true);
        setToast({message: locale.dashboardHeaderConversations.f, color: 'info', display: 'bottom', duration: 1000});
        if (!Empty(teamtalk)) {
            setTeamtalk({});
        } else {
            const currentTab = conversations.find(item => item.id === navigation.tab);
            if (currentTab.timestamp) {
                setText('<p></p>');
                window.localStorage.text = '<p></p>';
            }
        }

        const message = {
            type: 'wss',
            path: 'tab',
            action: 'get',
            data: {
                id: data.id
            }
        };
        wsCall(message);
        DialogClose();
    }

    const ListData = () => {
        if (text) {
            return results;
        } else if (tab === 'archives') {
            return archives;
        } else if (tab === 'teamtalks') {
            return teamtalks;
        } else if (tab === 'conversations') {
            return conversations;
        }
    }

    const InputSuggestion = data => {
        setText(data);
        const query = data.trim().toLowerCase();

        if (!query) {
            setResults([]);
            return;
        }

        if (tab === 'archives') {
            const filtered = archives.filter(item =>
                item.text.toLowerCase().includes(query)
            );
            setResults(filtered);
        } else if (tab === 'teamtalks') {
            const filtered = teamtalks.filter(item =>
                item.name.toLowerCase().includes(query)
            );
            setResults(filtered);
        } else if (tab === 'conversations') {
            const filtered = conversations.filter(item =>
                item.name.toLowerCase().includes(query)
            );
            setResults(filtered);
        }
    };

    const ButtonSort = () => {
        if (results.length !== 0) {

            setResults(prev => [...prev].sort((a, b) => sort ? Number(a.timestamp) - Number(b.timestamp) : Number(b.timestamp) - Number(a.timestamp)));
        }
        if (results.length === 0 && archives.length !== 0) {

            setArchives(prev => [...prev].sort((a, b) => sort ? Number(a.timestamp) - Number(b.timestamp) : Number(b.timestamp) - Number(a.timestamp)));
        }
        if (sort) {
            setSort(false);
        } else {
            setSort(true);
        }
    }

    const GetTeamtalkConversations = useCallback(data => {
        if (data.conversations) {
            data.conversations.unshift({avatar: null, model: null, voice: 'nova', personality: 'general_assistant', name: locale.dashboardHeaderConversations.b, id: '1', new: true})
            setTeamtalks(data.conversations);
        } else {
            setTeamtalks([{avatar: null, model: null, voice: 'nova', personality: 'general_assistant', name: locale.dashboardHeaderConversations.b, id: '1', new: true}]);
        }
        setTab('teamtalks');
        setLoading(false);
    }, [locale.dashboardHeaderConversations.b]);

    const UpdateTabSort = useCallback(data => {
        if (data.toast) {

        }
    }, []);

    const GetConversations = useCallback(data => {
        if (data.tabs) {
            setConversations(TabOrder(data.tabs, data.sort));
        } else {
            setConversations([]);
        }
        setTab('conversations');
        setLoading(false);
    }, []);

    const GetConversationArchives = useCallback(data => {
        if (data.conversations) {
            setArchives(data.conversations);
        } else {
            setArchives([]);
        }
        setTab('archives');
        setLoading(false);
    }, []);

    const DeleteConversationArchive = useCallback(data => {
        if (data.toast) {
            setToast({message: locale.dashboardHeaderConversations.a, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.conversations) {
            setArchives(data.conversations);
        } else {
            setArchives([]);
        }
    }, [locale.dashboardHeaderConversations.n]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'conversation-archive') {
            DeleteConversationArchive(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteConversationArchive, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'conversation-archives') {
            GetConversationArchives(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetConversationArchives, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'conversations') {
            GetConversations(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetConversations, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'tab-sort') {
            UpdateTabSort(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateTabSort, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'teamtalk-conversations') {
            GetTeamtalkConversations(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetTeamtalkConversations, setWsResponse]);

    useEffect(() => {
        Conversations();
    }, []);

    return (
        <Popup className="cs-dashboard-header-conversations-popup" display="top" fullScreen={true} scrollLock={false} maxHeight={width > 768 ? 700 : 600} buttons={configuration.teamtalk ? [{text: locale.dashboardHeaderConversations.e, cssClass: tab === 'archives' ? 'cs-dashboard-header-conversations-header-select' : 'cs-dashboard-header-conversations-header', handler: function (event) {tab !== 'archives' && Archives();}}, {text: locale.dashboardHeaderConversations.c, cssClass: tab === 'teamtalks' ? 'cs-dashboard-header-conversations-header-select' : 'cs-dashboard-header-conversations-header', handler: function (event) {tab !== 'teamtalks' && Teamtalks();}}, {text: locale.dashboardHeaderConversations.a, cssClass: tab === 'conversations' ? 'cs-dashboard-header-conversations-header-select' : 'cs-dashboard-header-conversations-header', handler: function (event) {tab !== 'conversations' && Conversations();}}] : [{text: locale.dashboardHeaderConversations.e, cssClass: tab === 'archives' ? 'cs-dashboard-header-conversations-header-select' : 'cs-dashboard-header-conversations-header', handler: function (event) {tab !== 'archives' && Archives();}}, {text: locale.dashboardHeaderConversations.a, cssClass: tab === 'conversations' ? 'cs-dashboard-header-conversations-header-select' : 'cs-dashboard-header-conversations-header', handler: function (event) {tab !== 'conversations' && Conversations();}}]} isOpen={dialog.view === 'dashboardHeaderConversations'} onClose={DialogClose}>
            {loading &&
                <Loading />
            }
            {!loading &&
                <div className="mbsc-grid cs-dashboard-header-conversations-header-col">
                    <div className="mbsc-row cs-dashboard-header-conversations-header-row">
                        <div className="mbsc-col cs-dashboard-header-conversations-header-col cs-dashboard-header-conversations-select">
                            <Input
                                inputStyle="underline"
                                placeholder={locale.dashboardHeaderConversations.d}
                                labelStyle="floating"
                                type="text"
                                name="search"
                                value={text}
                                onChange={ev => InputSuggestion(ev.target.value)}
                            />
                        </div>
                        {tab === 'archives' &&
                            <div className="mbsc-col-auto cs-dashboard-header-conversations-col-sort">
                                <Button className="mbsc-bold" variant="flat" onClick={() => ButtonSort()} >
                                    <FontAwesomeIcon className="cs-dashboard-header-conversations-sort-button" icon={sort ? faArrowDownWideShort : faArrowUpShortWide} />
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            }
            {!loading &&
                <div className="cs-dashboard-header-conversations-scroll">
                    <Listview
                        theme="ios"
                        themeVariant="light"
                        select="single"
                        sortable={(!text && tab === 'conversations') ? true : false}
                        itemType={ListItem}
                        data={ListData()}
                        onInit={(event, inst) => setListInstance(inst)}
                        onSortStart={function (event, inst) {
                            sortStart.current = event.index;
                        }}
                        onSortEnd={function (event, inst) {
                            Sort(event.index);
                        }}
                        actionsWidth={tab === 'archives' ? 100 : null}
                        actions={tab === 'archives' ? {
                            right: [{
                                color: '#0B7DBB',
                                text: locale.dashboardHeaderConversations.g,
                                action: (event, inst) => {
                                    const item = (text && results.length !== 0) ? results[event.index] : archives[event.index];
                                    setArchive(item);
                                    Dialog({view: 'dashboardHeaderConversationRename'});

                                    inst.close(event.target);
                                    return false;
                                }
                            }, {
                                color: '#0B7DBB',
                                text: locale.dashboardHeaderConversations.h,
                                action: (event, inst) => {
                                    const item = (text && results.length !== 0) ? results[event.index] : archives[event.index];
                                    setArchive(item);
                                    Dialog({view: 'dashboardHeaderConversationDuplicate'});

                                    return false;
                                }
                            }, {
                                color: '#0B7DBB',
                                text: locale.dashboardHeaderConversations.i,
                                action: (event, inst) => {
                                    confirm({
                                        title: locale.dashboardHeaderConversations.j,
                                        message: locale.dashboardHeaderConversations.k,
                                        okText: locale.dashboardHeaderConversations.i,
                                        cancelText: locale.dashboardHeaderConversations.l,
                                        callback: (res) => {
                                            if (res) {
                                                const item = (text && results.length !== 0) ? results[event.index].timestamp : archives[event.index].timestamp;

                                                const message = {
                                                    type: 'wss',
                                                    path: 'conversation-archive',
                                                    action: 'delete',
                                                    data: {
                                                        conversation: item
                                                    }
                                                };
                                                wsCall(message);
                                            } else {
                                                inst.close(event.target);
                                            }
                                        }
                                    });
                                    return false;
                                }
                            }, {
                                color: '#0B7DBB',
                                text: locale.dashboardHeaderConversations.m,
                                action: (event, inst) => {
                                    const item = (text && results.length !== 0) ? results[event.index] : archives[event.index];
                                    setArchive(item);
                                    Dialog({view: 'dashboardHeaderConversationNew', tab: 'archive'});

                                    return false;
                                }
                            }]
                        } : null}
                    />
                </div>
            }
        </Popup>
    );
}

export default DashboardHeaderConversations;
